import React, { useState, useEffect, useContext, useRef } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import MisGirasTableComponent from "../../components/tables/MisGirasTableComponent";
import ConvenioModal from "../../components/ConvenioModal";

import PageLayout from "../../layouts/PageLayout";
import products from "../../assets/data/misgiras.json";

import { getMisGiras } from "../../api/giras.ts";
import { verificarConvenio } from "../../api/convenios.api.ts";

export default function MisGirasListPage() {

    const { t } = useContext(TranslatorContext)

    const [giras, setGiras] = useState([]);
    const [showConvenioModal, setShowConvenioModal] = useState(false);
    const [alumnoActual, setAlumnoActual] = useState(null);
    const [conveniosVerificados, setConveniosVerificados] = useState({});
    const verificacionIniciada = useRef(false);

    useEffect(() => {
         const fetchTabla = async () => {
             const res = await getMisGiras();
             setGiras(res);
             
             // Verificar convenios para cada alumno solo una vez
             if (res && res.length > 0 && !verificacionIniciada.current) {
                 verificacionIniciada.current = true;
                 verificarConveniosPendientes(res);
             }
         }
    
         fetchTabla();   
         // eslint-disable-next-line react-hooks/exhaustive-deps
     }, []);

    /**
     * Verifica si hay convenios pendientes de aceptar
     */
    const verificarConveniosPendientes = async (girasData) => {
        try {
            const verificados = {};
            
            // Verificar cada alumno
            for (const gira of girasData) {
                if (gira.alu_id && gira.gir_id) {
                    const key = `${gira.alu_id}_${gira.gir_id}`;
                    
                    // Evitar verificar si ya fue verificado en esta sesión
                    if (conveniosVerificados[key]) {
                        continue;
                    }
                    
                    try {
                        const resultado = await verificarConvenio(gira.alu_id, gira.gir_id);
                        
                        verificados[key] = !resultado.necesitaAceptar;
                        
                        // Si necesita aceptar y no hemos mostrado aún ningún modal
                        if (resultado.necesitaAceptar && !alumnoActual) {
                            setAlumnoActual(gira);
                            setShowConvenioModal(true);
                            break; // Solo mostrar uno a la vez
                        }
                    } catch (err) {
                        console.error(`Error verificando convenio para alumno ${gira.alu_id}:`, err);
                    }
                }
            }
            
            setConveniosVerificados(prev => ({ ...prev, ...verificados }));
        } catch (err) {
            console.error("Error verificando convenios:", err);
        }
    };

    /**
     * Maneja cuando se acepta un convenio
     */
    const handleConvenioAceptado = () => {
        if (alumnoActual) {
            const key = `${alumnoActual.alu_id}_${alumnoActual.gir_id}`;
            setConveniosVerificados(prev => ({
                ...prev,
                [key]: true
            }));
        }
        
        setShowConvenioModal(false);
        setAlumnoActual(null);
        
        // Verificar si hay más convenios pendientes
        const alumnosPendientes = giras.filter(gira => {
            const key = `${gira.alu_id}_${gira.gir_id}`;
            return !conveniosVerificados[key] && gira.alu_id !== alumnoActual?.alu_id;
        });
        
        if (alumnosPendientes.length > 0) {
            // Mostrar el siguiente convenio pendiente
            setTimeout(() => {
                verificarConveniosPendientes(alumnosPendientes);
            }, 1000);
        }
    };

    /**
     * Maneja cuando se cierra el modal sin aceptar
     */
    const handleConvenioClose = () => {
        setShowConvenioModal(false);
        // No resetear alumnoActual para evitar que se vuelva a mostrar
    };

    return (
        <PageLayout>
            <Row>
               
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Mis Giras</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                              
                                <li className="mc-breadcrumb-item">Giras</li>
                            </ul>
                        </div>
                    </div>
                </Col>
               
                <Col xl={12} >
                    <div className="mc-card">
                        <Row  style={{ height: '650px' }}>
                            
                            <Col xl={12}>
                                <MisGirasTableComponent 
                                    thead={ products.thead } 
                                    data={giras}
                                />
                                <MisGirasTableComponent />
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            
            {/* Modal de Convenio */}
            {alumnoActual && (
                <ConvenioModal
                    show={showConvenioModal}
                    aluId={alumnoActual.alu_id}
                    girId={alumnoActual.gir_id}
                    alumnoNombre={`${alumnoActual.alu_nombres} ${alumnoActual.alu_apellidos}`}
                    onAccepted={handleConvenioAceptado}
                    onClose={handleConvenioClose}
                />
            )}
        </PageLayout>
    );
}
